import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import Loader from "../components/other/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../components/other/NoRecord";
import { firebaseRemoveUserFromGroup } from "../redux/action/groupAction";
import { pipViewDate } from "../utils/pip";
import PaginationDropdown from "../components/PaginationDropdown";
import ReactPagination from "../components/reactPagination";

const GroupMember = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isToggle } = useSelector((state) => state.authReducer);

  const { member } = location.state;
  const [selectedMember, setSelectedMember] = useState(null);
  const { isLoading } = useSelector((state) => state.groupReducer);
  const [selectedImage, setSelectedImage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  const handleRemoveMember = () => {
    if (!selectedMember) return;
    const data = {
      groupId: member?.groupId,
      userId: String(selectedMember?.id),
      groupType: member?.groupType,
    };

    const callback = (response) => {
      if (response?.success) {
        navigate(pageRoutes?.groups);
      }
    };
    dispatch(firebaseRemoveUserFromGroup({ payload: data, callback }));
  };

  const formattedLookingFor = (lookingFor) => {
    if (Array.isArray(lookingFor)) {
      return lookingFor.join(", ");
    }
    return lookingFor
      ? lookingFor
          .split(",")
          .map((part) => part.trim())
          .join(", ")
      : "";
  };

  const paginatedGroupMember = member.member?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleGroupImage = (group) => {
    setSelectedImage(group.image);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_inner_dashbaord_main">
            <div>
              <ul class="d-flex align-items-center  gap-2 mb-0">
                <li>
                  {" "}
                  <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                    Group Members
                  </h4>
                </li>
                <li>
                  <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                    <i className="bi bi-dot"></i>
                  </h4>
                </li>
                <li>
                  {" "}
                  <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0 ct_orange_text">
                    {member.groupName}
                  </h4>
                </li>
              </ul>
            </div>

            <div class="">
              <div className="table-responsive">
                <table className="table ct_custom_table">
                  <thead>
                    <tr>
                      {" "}
                      <th>S.No.</th>
                      <th></th>
                      <th>Name & Location</th>
                      <th>Gender & Looking For</th>
                      <th>Age</th>
                      <th>Join Date</th>
                      <th>Social Account</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {paginatedGroupMember && paginatedGroupMember != 0 ? (
                    paginatedGroupMember.map((item, index) => {
                      return (
                        <tbody>
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={item?.image ?? "./user_profile2.png"}
                                  alt=""
                                  class="ct_img_36 ct_pointer_curser"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_user_img_preview"
                                  onClick={() => handleGroupImage(item)}
                                />
                              </div>
                            </td>
                            <td>
                              <div class="d-flex align-items-center gap-2 ">
                                {/* <img
                                  src={item?.image ?? "./user_profile2.png"}
                                  alt=""
                                  class="ct_img_36 ct_pointer_curser"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_user_img_preview"
                                  onClick={() => handleGroupImage(item)}
                                /> */}
                                <div>
                                  <h5 class="ct_fs_14 ct_fw_700 mb-0">
                                    {item?.user[0]?.name ?? ""}
                                  </h5>
                                  <p class="mb-0 ct_fs_14 ct_fw_500">
                                    <i class="bi bi-geo-alt me-2"></i>
                                    {item?.user[0]?.city ?? ""}
                                    {item?.user[0]?.city &&
                                      item?.user[0]?.country &&
                                      ","}{" "}
                                    {item?.user[0]?.country ?? ""}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="">
                                <p class="mb-1 ct_fw_600 ct_fs_16">
                                  {item?.user[0].gender ?? ""}
                                </p>
                                <p class="mb-0 ct_fw_600 ct_fs_16 ct_white_space_3_dot_12">
                                  {" "}
                                  {formattedLookingFor(
                                    item?.user[0]?.looking_for
                                  ) ?? ""}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div className="">
                                <p class="mb-0 ct_fw_600 ct_fs_16">
                                  {item?.user[0]?.age} Years
                                </p>
                              </div>
                            </td>
                            <td>
                              <div className="">
                                <p class="mb-0 ct_fw_600 ct_fs_16">
                                  <span>
                                    {pipViewDate(item?.user[0]?.created_at)}
                                  </span>
                                </p>
                              </div>
                            </td>
                            <td>
                              <ul class="d-flex align-items-center gap-3">
                                {item?.user[0]?.facebook_link && (
                                  <li>
                                    <a
                                      href={`https://www.facebook.com/${encodeURIComponent(
                                        item?.user[0]?.facebook_link
                                      )}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa-brands fa-facebook ct_fs_20 text-dark"></i>
                                    </a>
                                  </li>
                                )}
                                {item?.user[0]?.twitter_link && (
                                  <li>
                                    <a
                                      href={`https://www.twitter.com/${encodeURIComponent(
                                        item?.user[0]?.twitter_link
                                      )}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa-brands fa-twitter ct_fs_20 text-dark"></i>
                                    </a>
                                  </li>
                                )}
                                {item?.user[0]?.instagram_link && (
                                  <li>
                                    <a
                                      href={`https://www.instagram.com/${encodeURIComponent(
                                        item?.user[0]?.instagram_link
                                      )}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa-brands fa-instagram ct_fs_20 text-dark"></i>
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </td>
                            <td class="text-end">
                              <div className="ct_pointer_curser">
                                <div
                                  className=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_delete_modal"
                                >
                                  <i
                                    class="fa-solid fa-trash-can ct_pointer_curser text-danger ct_fs_24"
                                    onClick={() => setSelectedMember(item)}
                                  ></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      );
                    })
                  ) : (
                    <tr>
                      <NoRecord />
                    </tr>
                  )}
                </table>
              </div>
            </div>
            {paginatedGroupMember && paginatedGroupMember?.length != 0 && (
              <>
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <div>
                    <PaginationDropdown
                      onChange={(val) => {
                        setUserPerPages(val);
                        setCurrentPage(0);
                      }}
                    />
                  </div>
                  <div>
                    <ReactPagination
                      pageCount={Math.ceil(
                        member.member?.length / usersPerPage
                      )}
                      onPageChange={handlePageClick}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
 
        {/* modal  start */}
        <div
          class="modal fade ct_assets_modal"
          id="ct_delete_modal"
          tabindex="-1"
          aria-labelledby="ct_delete_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border-0 pt-0">
                <button
                  type="button"
                  class="btn-close ct_cloose_btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div class="modal-body border-0 ">
                <i className="fa-solid fa-trash-can ct_red_text ct_fs_30 text-center d-block mb-4"></i>
                <h4 class="text-center mb-2 ct_fw_600">Confirm Delete</h4>
                <p className="text-center mb-0">
                  Are you sure? you want to delete it.
                </p>

                <div class="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    class="ct_orange_btn ct_cancel_btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <a
                    type="button"
                    class=" bg-danger  ct_orange_btn  justify-content-center"
                    style={{ borderColor: "rgb(220, 53, 69)" }}
                    data-bs-dismiss="modal"
                    onClick={handleRemoveMember}
                  >
                    Delete
                  </a>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div
        class="modal fade ct_assets_modal"
        id="ct_user_img_preview"
        tabindex="-1"
        aria-labelledby="ct_user_img_previewLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header pb-0 border-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mt-0">
              <img
                src={selectedImage || "./user_profile.png"}
                alt=""
                class="ct_img_400_big"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupMember;
